/**
 * AGC Swatch Image Swap (Symmetry desktop fix)
 *
 * Symmetry's per-card swatch handler moves a `--active` class to a hidden
 * `.product-block__image` wrapper but never updates the visible
 * `--primary` wrapper's <img>. Mobile happens to render whichever wrapper
 * has --active, but desktop keeps --primary visible regardless, so swatch
 * clicks appear inert on desktop.
 *
 * This script copies the matching wrapper's <img src>/srcset/sizes/alt
 * into the primary wrapper on every swatch click — no markup changes,
 * scoped to <product-block> cards only.
 */
(function () {
  if (window.__agcSwatchSwapInit) return;
  window.__agcSwatchSwapInit = true;

  function swap(swatch) {
    var card = swatch.closest('product-block, .product-block');
    if (!card) return;

    var mediaId = swatch.getAttribute('data-media');
    if (!mediaId) return;

    var primary = card.querySelector('.product-block__image--primary');
    if (!primary) return;

    var primaryImg = primary.querySelector('img');
    if (!primaryImg) return;

    var target = card.querySelector('.product-block__image[data-media-id="' + mediaId + '"]');
    if (!target) return;
    var targetImg = target.querySelector('img');
    if (!targetImg) return;

    // No-op if already matching (avoids redundant network hits)
    if (primaryImg.src === targetImg.src) return;

    // Cache the very first src once so a second click can restore the original.
    if (!primary.dataset.agcOriginalSrc) {
      primary.dataset.agcOriginalSrc = primaryImg.src;
      primary.dataset.agcOriginalSrcset = primaryImg.srcset || '';
      primary.dataset.agcOriginalAlt = primaryImg.alt || '';
    }

    primaryImg.src = targetImg.src;
    if (targetImg.srcset) primaryImg.srcset = targetImg.srcset;
    if (targetImg.sizes)  primaryImg.sizes  = targetImg.sizes;
    primaryImg.alt = targetImg.alt || primaryImg.alt;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;
    var swatch = t.closest && t.closest('[data-swatch][data-media]');
    if (!swatch) return;
    // Defer one tick so Symmetry's own handler can run first (sets --active class etc.).
    setTimeout(function () { swap(swatch); }, 0);
  }, true);
})();
